type Keys = 'imprint' | 'termsAndConditions';

type Links = {
  [K in Keys]: string;
};

export const links: Links = {
  imprint: 'https://www.timify.com/en-gb/pages/imprint/',
  termsAndConditions: 'https://www.timify.com/en-gb/pages/terms-of-use-smb/',
};
